import { ChevronDownIcon, PlusIcon } from "@heroicons/react/24/outline";

import {
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownItem,
  DropdownSection,
} from "V2.0/common/dropdown";

import { CAMPAIGN_TYPE } from "../BulkCampaigns/BulkCampaignCreate";
import { CampaignTypeIcons } from "../common/CampaignTypeIcons";

export default function FollowUpAdd(props) {
  const { onAddFollowUp } = props;

  return (
    <Dropdown>
      <DropdownButton>
        <PlusIcon /> Follow Up
        <ChevronDownIcon />
      </DropdownButton>
      <DropdownMenu className="min-w-40">
        <DropdownSection className="flex flex-col gap-y-2">
          <DropdownItem
            onClick={() => {
              onAddFollowUp(CAMPAIGN_TYPE.SMS);
            }}
          >
            <div className="flex items-center gap-x-2">
              <div>{CampaignTypeIcons[CAMPAIGN_TYPE.SMS]}</div>
              <p className="text-sm">Sms</p>
            </div>
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              onAddFollowUp(CAMPAIGN_TYPE.CALL);
            }}
          >
            <div className="flex items-center gap-x-2">
              <div>{CampaignTypeIcons[CAMPAIGN_TYPE.CALL]}</div>
              <p className="text-sm">Call</p>
            </div>
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              onAddFollowUp(CAMPAIGN_TYPE.WHATSAPP);
            }}
          >
            <div className="flex items-center gap-x-2">
              <div>{CampaignTypeIcons[CAMPAIGN_TYPE.WHATSAPP]}</div>
              <p className="text-sm">Whatsapp</p>
            </div>
          </DropdownItem>
        </DropdownSection>
      </DropdownMenu>
    </Dropdown>
  );
}
